/*
 * @Author: your name
 * @Date: 2021-12-20 10:04:27
 * @LastEditTime: 2022-03-25 11:48:23
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /download/src/store/modules/app-module.ts
 */
import { GAME_DATA, GAME_INFO } from '@/data/game'
import { inAndroid, inIOS, inMobile } from '@/data/runtime'
import { router } from '@/define'

import { BaseModule } from '../base'

const ua = navigator.userAgent
export interface IConfig {
    template: string
    folder: string | null
    data?: any
}
export interface IGameInfo {
    /** 内容有点多, 调下接口看下. */
    gameDetail?: any
    giftbags?: Array<any>
    recommendGames: Array<any>
}
export interface IAppModel {
    gameId: string
    channelId: string
    officialCpsChl: boolean
    shortChain: string
    h5GameUrl: string
    guideImgs: string
    isOnlyH5: boolean
    gameInfo?: IGameInfo | null
}

/** app 能力 */
export class AppModule extends BaseModule<IAppModel> {
    protected initData(): IAppModel {
        return {
            gameId: '',
            channelId: '',
            officialCpsChl: false,
            shortChain: '',
            h5GameUrl: '',
            guideImgs: '',
            isOnlyH5: false,
            gameInfo: null
        }
    }

    get gameId(): string {
        return this.state.gameId
    }

    get channelId(): string {
        return this.state.channelId
    }

    get officialCpsChl(): boolean {
        return this.state.officialCpsChl
    }

    get h5GameUrl(): string {
        return this.state.h5GameUrl
    }

    get guideImgs(): string {
        return this.state.guideImgs
    }

    get isOnlyH5(): boolean {
        return this.state.isOnlyH5
    }

    get gameInfo(): IGameInfo {
        return this.state.gameInfo as IGameInfo
    }

    get config(): IConfig | null {
        const { gameId } = this.state
        if (gameId) {
            const keys: Array<string> = Object.keys(GAME_DATA)
            const key = keys.find((k) => new RegExp(gameId).test(k))
            if (key) return GAME_DATA[key]
            else if (this.gameInfo) return { template: 'V1', folder: null }
        }
        return null
    }

    /** actions */

    /** 解析url中携带的短链shortChain，并通过短链获取 gameId, channelId 参数 */
    async parseUrl(): Promise<void> {
        const route = router.match(location.pathname)
        const { shortChain } = route?.params ?? {}
        this.commit('shortChain', shortChain)

        // 人工定制页面:https://init.sdk.v2.dakongy.com
        if (shortChain == 'jfzzsg') {
            this.commit('gameId', '6235908887072643')
            this.commit('channelId', '')
            return
        }
        if (shortChain == 'jfzzsg2') {
            this.commit('gameId', '6219309872643')
            this.commit('channelId', '')
            return
        }
        try {
            const { data } = await this.$apis.common.gameChannelInfo({ sign: shortChain })
            if (data.gameId) {
                const checkData = await this.$apis.common.checkChannelId({
                    gameId: data?.gameId,
                    channelId: data?.channelId
                })
                this.commit('gameId', data?.gameId)
                this.commit('channelId', data?.channelId)
                this.commit('officialCpsChl', checkData?.data?.officialCpsChl)
            } else {
                router.replace('/404')
            }
        } catch (e) {
            router.replace('/404')
        }
    }

    async loadGameInfo(): Promise<void> {
        const { gameId, channelId } = this.state
        let osType: number
        if (inAndroid || !inMobile) osType = 2
        else osType = 1
        // 人工定制页面:https://init.sdk.v2.dakongy.com
        if (['6235908887072643', '6219309872643'].includes(gameId)) {
            this.commit('gameInfo', { ...GAME_INFO })
            return
        }
        try {
            const { data } = await this.$apis.common.getGameDetail({ gameId, channelId, osType })
            if (data.gameDetail.h5GameUrl) {
                this.commit('h5GameUrl', data.gameDetail.h5GameUrl)
                this.commit('guideImgs', 'https://aiyoufile.obs.cn-east-3.myhuaweicloud.com/pic/guideimg.gif')
                this.commit('isOnlyH5', true)
            }
            if (data.gameDetail.signType == '3' && data.gameDetail.osType == '1' && inIOS) {
                window.location.href = data.gameDetail.pkgPath
            } else {
                this.commit('gameInfo', { ...data })
            }
        } catch (e) {
            router.replace('/404')
        }
    }

    async loadWeChatGameInfo(): Promise<void> {
        const { gameId } = this.state
        try {
            const { data } = await this.$apis.wxDownload.getWechatGameDetail({ gameId })
            if (data.h5GameUrl && data.iosLandingPage == '') {
                this.commit('h5GameUrl', data.h5GameUrl)
                this.commit('guideImgs', data.iosInstallGuide)
                this.commit('isOnlyH5', true)
            }
        } catch (e) {
            router.replace('/404')
        }
    }
}
